import { z } from "zod";

import { medRoomChecklistItem } from "../../../schemas";

export const bhMedRoomStep1Schema = z.object({
  auditDate: z.date().max(new Date(), "Future date not allowed."),
  locationId: z.string().min(1, "Required"),
  reviewerId: z.string().min(1, "Required"),
  handHygienePosted: medRoomChecklistItem,
  handHygienePerformed: medRoomChecklistItem,
  firstAidKit: medRoomChecklistItem,
  ppePresent: medRoomChecklistItem,
  twoPersonIdentifiers: medRoomChecklistItem,
  medAdministrationObserved: medRoomChecklistItem,
  medRoomClean: medRoomChecklistItem,
  medSeparate: medRoomChecklistItem,
  medClosetTemp: medRoomChecklistItem,
  medClosetLight: medRoomChecklistItem,
  medSupplies: medRoomChecklistItem,
  orderedMedLabeled: medRoomChecklistItem,
  individualMedSeparated: medRoomChecklistItem,
});

export const bhMedRoomStep2Schema = z.object({
  medLocked: medRoomChecklistItem,
  controlledSubstanceLog: medRoomChecklistItem,
  controlledSubstanceLocked: medRoomChecklistItem,
  controlledSubstanceLockedFridge: medRoomChecklistItem,
  expiredMed: medRoomChecklistItem,
  medDestructionArea: medRoomChecklistItem,
  emergencyMed: medRoomChecklistItem,
  medPrepared: medRoomChecklistItem,
  sharpsContainer: medRoomChecklistItem,
  foodStorage: medRoomChecklistItem,
  medRefrigeratorTemperature: medRoomChecklistItem,
  doNotUseAbbreviation: medRoomChecklistItem,
  lookAlikeSoundAlike: medRoomChecklistItem,
  highAlertMed: medRoomChecklistItem,
  cliaWaivedTest: medRoomChecklistItem,
});

export const bhMedRoomStep3Schema = z
  .object({
    testSpecimenLabeled: medRoomChecklistItem,
    medCount: medRoomChecklistItem,
    medTrainedStaff: medRoomChecklistItem,
    waivedTestingControls: medRoomChecklistItem,
    disposalForm: medRoomChecklistItem,
    medicationErrorForm: medRoomChecklistItem,
    medicationErrorReported: medRoomChecklistItem,
    medicationErrorFollowUp: medRoomChecklistItem,
    fileDisposalForm: z.union([z.instanceof(File), z.null()]).optional(),
    fileMedCount: z.union([z.instanceof(File), z.null()]).optional(),
  })
  .superRefine((data, ctx) => {
    const disposalSize = data.fileDisposalForm?.size ?? 0;
    const medCountSize = data.fileMedCount?.size ?? 0;

    if (disposalSize > 2 * 1024 * 1024) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Max 2 MB",
        path: ["fileDisposalForm"],
      });
    }

    if (medCountSize > 2 * 1024 * 1024) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Max 2 MB",
        path: ["fileMedCount"],
      });
    }
  });
